import http from "./http";

/* ================================
   BONUS SERVICE
================================ */

/**
 * Get Register Bonus
 * GET: /api/super-admin/manage_bonus
 */
export const getBonus = async () => {
  const res = await http.get("manage_bonus");
  return res.data;
};

/**
 * Update Register Bonus
 * POST: /api/super-admin/manage_bonus
 */
export const updateBonus = async ({
  id,
  register_bonus,
  remark,
  status,
}) => {
  const res = await http.post("manage_bonus", {
    action: "edit",
    id,
    register_bonus,
    remark,
    status,
  });

  return res.data;
};
